<template>
    <div>
        <div v-if="loading">
            <div class="spinner"></div>
        </div>

        <div v-else-if="errors.length" class="alert--error" >
            <p v-for="err in errors" :key="err"> {{ err }} </p>
        </div>

        <form v-if="!loading" class="form" @submit.prevent="save">
            <slot name="header"></slot>

            <div :class="wrapperClass">
                <div class="form__item">
                    <i class="form__icon icons icon-calendar"></i>
                    <input v-model="application.date" class="form__input--text has-value" required type="date"/>
                    <label class="form__label">{{$t('forms.application.date')}}</label>
                </div>
                <div class="form__item">
                    <i class="form__icon icons icon-user"></i>
                    <input v-model="application.vacancy" class="form__input--text" type="text" required :class="{ 'has-value': application.vacancy }"/>
                    <label class="form__label">{{$t('forms.application.vacancy')}}</label>
                </div>
                <div class="form__item">
                    <i class="form__icon icons icon-briefcase"></i>
                    <input v-model="application.company" class="form__input--text" type="text" required :class="{ 'has-value': application.company }"/>
                    <label class="form__label">{{$t('forms.application.company')}}</label>
                </div>

                <template v-if="!application.id">
                    <h2>{{$t('forms.application.attachment')}}</h2>
                    <input v-if="!applicationAttachmentUploading" type="file" accept=".pdf, .doc, .docx, .png, .jpg, .jpeg, .bmp, .gif" name="applicationAttachmentInput" id="applicationAttachmentInput" ref="applicationAttachmentInput" style="display:none" @change="onApplicationAttachmentSelected">
                    <loading-button @submited="$refs.applicationAttachmentInput.click()" :loading="applicationAttachmentUploading" :text="$t('common.choose_file')"></loading-button>
                    <span> {{applicationAttachment ? applicationAttachment.name : ''}} </span>
                </template>
            </div>

            <slot name="buttons" :isSaveDisabled="isSaveDisabled">
                <div class="form__buttons">
                    <button type="submit" class="form__button button--cta" :class="{disabled: isSaveDisabled}" :disabled="isSaveDisabled">{{$t('common.save')}}</button>
                </div>
            </slot>
        </form>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { Component, Prop } from 'vue-property-decorator';
    import Application from '@/models/Application';
    import LoadingButton from '@/components/general/LoadingButton';

    @Component({
        components: {
            LoadingButton,
        }
    })
    export default class ApplicationForm extends Vue {

        @Prop({ type: Array | String, default() {
            return [];
        } })
        wrapperClass;

        @Prop({ type: Application, default() {
            return new Application();
        } })
        application;

        created() {
            this.errors = [];
        }

        get isSaveDisabled() {
            return !this.application.date || !this.application.vacancy || !this.application.company;
        }

        saveLoading = false;
        applicationAttachmentUploading = false;
        applicationAttachment  = null;

        get loading () {
            return this.saveLoading;
        }

        onApplicationAttachmentSelected(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;
            this.applicationAttachment = files[0];
        }

        uploadApplicationAttachment(applicationId) {
            if (!this.applicationAttachment) return;

            var formData = new FormData();
            formData.append('file', this.applicationAttachment, this.applicationAttachment.name);

            this.applicationAttachmentUploading = true;
            this.errors = [];
            this.axios.post(`trajectories/${this.$store.state.trajectory.trajectory.id}/applications/${applicationId}/files`, formData)
                .then(res => this.$emit('saved', res))
                .catch(err => {
                    if (err.status === 422 && err.errors) {
                        this.errors = err.errors;
                        this.$notify.error(this.$t('common.validation_error'));
                    }
                }).then(() => {
                    this.applicationAttachmentUploading = false;
                });
        }

        save() {
            this.errors = [];
            this.saveLoading = true;
            this.application.save()
                .then(res => this.applicationAttachment ? this.uploadApplicationAttachment(res.id) : this.$emit('saved', res))
                .catch(
                    err => {
                        if (err.status === 422) {
                            this.errors = err.errors;
                        } else {
                            this.errors = [this.$t('common.unknown_error')];
                        }
                    })
                .then(() => this.saveLoading = false);
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/forms/dashboard/ApplicationForm.vue